/* eslint-disable no-undef */
/* eslint-disable quotes */
import "/Features/Components/EmbeddedForm/js/mscrmmkt-events.js";
import "/Features/Components/EmbeddedForm/js/epiforms-events.js";
import "/Features/Forms/js/optimizely-forms.js";
import "/Features/Forms/js/cascading-form-container-block.js";
import "/Features/MediaGallery/js/media-gallery.js";
import "/Features/SupportByProduct/resources-by-product.js";
import "/Features/SupportByProduct/resources-by-product-block.js";
import "/Features/Components/ContactUs/contact-us-block.js";
import "/Features/GlobalLanding/global-landing.js";
import "/Features/LandingAndMicrosite/marquee.js";
import "/Features/Products/Listing/product-listing-page.js";
import "/Features/Calculators/PowermaxPaybackCalculator/powermax-payback-calculator.js";
import "/Features/Calculators/PlatesaverCostSavingsCalculator/platesaver.js";
import "/Features/Documents/document-listing-page.js";
import "/Features/WhereToBuy/js/where-to-buy.js";
import "/Features/WhereToBuy/js/where-to-buy-results.js";
import "/Features/ImageDownload/image-download-center.js";
import Triggers from "/Integrations/Dynamics365/Triggers/triggers.js";
import NotificationBar from "/Features/NotificationBar/notificationBar.js";
import TableHorizontalScroller from "/Assets/libs/table-horizontal-scroller.js";
import PaginationModal from "/Assets/libs/Modal/VanillaModal.js";
import ReadMore from "/Assets/libs/read-more.js";
import CustomerStorySlider from "/Features/CustomerStories/scripts/customer-stories-block.js";
import ButtonBlock from "/Features/Components/Button/button-block";
import ListingPages from "/Features/ListingPages/listing-pages.js";
import Shipbuilding from "/Features/Calculators/ShipbuildingCostCalculator/shipbuilding";
import HeroShotSlider from "/Features/HeroShot/hero-shot-slider.js";
import SiteSearch from "/Features/Search/js/site-search.js";
import VidyardEmbed from "@vidyard/embed-code";

// export to window so older javascript can access
window.LoadingSpinner = new PaginationModal("loadingSpinner", { transition: false });
window.VidyardEmbed = VidyardEmbed;

document.body.dataset.jsEnabled = "true";

let d365Triggers = new Triggers();
d365Triggers.init();

let notificationBar = new NotificationBar('notificationBar', 'accepted', 30);
notificationBar.init();

// Mobile table
let tableHorizontalScroll = new TableHorizontalScroller();
tableHorizontalScroll.init();

let heroShotSlider = new HeroShotSlider();
heroShotSlider.init();

let buttonBlock = new ButtonBlock();
buttonBlock.init();

let customerStorySlider = new CustomerStorySlider();
customerStorySlider.init();

let listingPages = new ListingPages();
listingPages.init();

let shipbuilding = new Shipbuilding();
shipbuilding.init();

let siteSearch = new SiteSearch();
siteSearch.init();

const readMoreOptions = {
    moreText: window.jsl10n.JsResources.Translations.Common.ReadMore,
    lessText: window.jsl10n.JsResources.Translations.Common.ReadLess
};
const readMores = document.querySelectorAll("div.shorten");
ReadMore(readMores, readMoreOptions).init();